import defaultReducer from "./defaultReducer";

export default defaultReducer("DOWNLOAD_REPORT_MODAL", {
  open: false,
  filename: "",
  onSave: () => {},
});
